import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const sourceMappingsRequest = createAction(
  types.SOURCE_MAPPINGS_REQUEST,
);
export const sourceMappingsSuccess = createAction(
  types.SOURCE_MAPPINGS_SUCCESS,
);
export const sourceMappingsFailure = createAction(
  types.SOURCE_MAPPINGS_FAILURE,
);

export const sourceMappingRequest = createAction(types.SOURCE_MAPPING_REQUEST);
export const sourceMappingSuccess = createAction(types.SOURCE_MAPPING_SUCCESS);
export const sourceMappingFailure = createAction(types.SOURCE_MAPPING_FAILURE);

export const createSourceMappingRequest = createAction(
  types.CREATE_SOURCE_MAPPING_REQUEST,
);
export const createSourceMappingSuccess = createAction(
  types.CREATE_SOURCE_MAPPING_SUCCESS,
);
export const createSourceMappingFailure = createAction(
  types.CREATE_SOURCE_MAPPING_FAILURE,
);

export const updateSourceMappingRequest = createAction(
  types.UPDATE_SOURCE_MAPPING_REQUEST,
);
export const updateSourceMappingSuccess = createAction(
  types.UPDATE_SOURCE_MAPPING_SUCCESS,
);
export const updateSourceMappingFailure = createAction(
  types.UPDATE_SOURCE_MAPPING_FAILURE,
);

export const resetSourceMapping = createAction(types.RESET_SOURCE_MAPPING);

export default {
  resetSourceMapping,
  sourceMappingRequest,
  sourceMappingSuccess,
  sourceMappingFailure,
  createSourceMappingRequest,
  createSourceMappingSuccess,
  createSourceMappingFailure,
  updateSourceMappingRequest,
  updateSourceMappingSuccess,
  updateSourceMappingFailure,
};
